import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseWeek extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseWeek {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseWeek;

  public mode() {
    return TEDParseDateTimeMode.pdmYW;
  }
}
